import { render, staticRenderFns } from "./ChecklistActivity3Form.vue?vue&type=template&id=198254a0&"
import script from "./ChecklistActivity3Form.vue?vue&type=script&lang=js&"
export * from "./ChecklistActivity3Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports